import { render, staticRenderFns } from "./CustomerShowGalleryDocument.vue?vue&type=template&id=33b7eb65"
import script from "./CustomerShowGalleryDocument.vue?vue&type=script&lang=js"
export * from "./CustomerShowGalleryDocument.vue?vue&type=script&lang=js"
import style0 from "./CustomerShowGalleryDocument.vue?vue&type=style&index=0&id=33b7eb65&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports